export default "__VITE_ASSET__9d6be325__"